"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSplittedTextByIndexRanges = void 0;
const getSplittedTextByIndexRanges = (text, indexRanges) => {
  if (!indexRanges.length) {
    return [{
      substring: text,
      isHighlighted: false
    }];
  }
  const splittedText = [];
  const firstRangeStartIndex = indexRanges[0]?.[0];
  if (firstRangeStartIndex !== undefined && firstRangeStartIndex > 0) {
    splittedText.push({
      substring: text.slice(0, firstRangeStartIndex),
      isHighlighted: false
    });
  }
  for (const [i, currentIndexRange] of indexRanges.entries()) {
    const currentRangeEndIndex = currentIndexRange[1];
    let nextRangeStartIndex = indexRanges[i + 1]?.[0];
    if (i === indexRanges.length - 1) {
      nextRangeStartIndex = text.length;
    }
    splittedText.push({
      substring: text.slice(currentIndexRange[0], currentIndexRange[1]),
      isHighlighted: true
    });
    if (currentRangeEndIndex !== undefined && currentRangeEndIndex < text.length) {
      splittedText.push({
        substring: text.slice(currentIndexRange[1], nextRangeStartIndex),
        isHighlighted: false
      });
    }
  }
  return splittedText;
};
exports.getSplittedTextByIndexRanges = getSplittedTextByIndexRanges;